import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@fc-core';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  canLoad(_route: Route): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate();
  }

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate();
  }

  canActivate() {
    if (this.auth.loggedIn()) {
      return true;
    } else {
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}
